module.exports = __webpack_public_path__ + "static/media/HACCP.6477b73b.png";